import React from 'react';

const notFoundStyle = `
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
`;

const NotFound = () => {
  return (
    <div 
      className="min-h-screen flex items-center justify-center relative overflow-hidden"
      style={{ background: notFoundStyle }}
    >
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-10 left-10 w-20 h-20 border border-white rounded-full"></div>
        <div className="absolute top-40 right-20 w-16 h-16 border border-white rounded-full"></div>
        <div className="absolute bottom-20 left-1/4 w-12 h-12 border border-white rounded-full"></div>
        <div className="absolute bottom-40 right-1/3 w-24 h-24 border border-white rounded-full"></div>
      </div>
      <div className="text-center text-white z-10 px-6">
        <div className="mb-8">
          <h1 className="text-9xl font-bold mb-4 opacity-80">404</h1>
          <div className="w-24 h-1 bg-white mx-auto mb-8 opacity-60"></div>
        </div>
        
        <h2 className="text-4xl font-light mb-6">Página Não Encontrada</h2>
        <p className="text-xl mb-8 opacity-90 max-w-md mx-auto">
          A página que você está procurando não existe ou foi movida.
        </p>
        
        <div className="space-y-4">
          <button
            onClick={() => window.location.href = '/'}
            className="bg-white text-gray-800 px-8 py-3 rounded-lg font-semibold hover:bg-gray-100 transition-colors duration-200 mr-4"
          >
            Voltar ao Início
          </button>
          <button
            onClick={() => window.history?.back()}
            className="border-2 border-white text-white px-8 py-3 rounded-lg font-semibold hover:bg-white hover:text-gray-800 transition-colors duration-200"
          >
            Página Anterior
          </button>
        </div>
      </div>
    </div>
  );
};

export default NotFound;